import { render, staticRenderFns } from "./question-type.vue?vue&type=template&id=50abe5e4&scoped=true&"
import script from "./question-type.vue?vue&type=script&lang=js&"
export * from "./question-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50abe5e4",
  null
  
)

export default component.exports